import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { TECH_VIDEOS as FALLBACK } from '../mock/mock';

const TechDevelopments = ({ videos }) => {
  const TECH_VIDEOS = videos && videos.length ? videos : FALLBACK;
  const [playing, setPlaying] = useState(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-[#8ec045] text-xs font-bold tracking-[4px] mb-3">
            YOUTUBE CHANNEL
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Technology &amp; Developments
          </h2>
          <p className="text-[#666]">Contribution towards energy solutions, tech innovation, &amp; trends</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TECH_VIDEOS.map((v) => (
            <div
              key={v.id}
              className="group relative aspect-video overflow-hidden cursor-pointer bg-black"
              onClick={() => setPlaying(v)}
            >
              <img
                src={v.thumbnail}
                alt={v.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-[#E10D0D] flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                  <Play className="w-6 h-6 text-white fill-white ml-1" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-semibold text-lg leading-snug">{v.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* YouTube modal */}
      {playing && (
        <div
          className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4 animate-in fade-in duration-200"
          onClick={() => setPlaying(null)}
        >
          <button
            onClick={() => setPlaying(null)}
            className="absolute top-6 right-6 text-white/80 hover:text-white z-10"
          >
            <X className="w-8 h-8" />
          </button>
          <div className="w-full max-w-5xl aspect-video" onClick={(e) => e.stopPropagation()}>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${playing.youtubeId}?autoplay=1`}
              title={playing.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default TechDevelopments;
